
import { GetCookie } from "@/utils/utils";
import axios from "axios";
import qs from 'qs';


const requestEvent = axios.create({
  maxContentLength: 5000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

// 请求拦截器
requestEvent.interceptors.request.use(
  config => {
    config.data = qs.stringify(config.data) // 转为formdata数据格式
    return config
  },
  error => Promise.error(error)
)

// 添加响应前拦截器
requestEvent.interceptors.request.use(
  (response) => {
    return response;
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
requestEvent.interceptors.response.use(
  (response) => {
    const data = response.data;

    return data;
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default (url, { data, address,isNoMid , ...parmas }) => {
  var uid = GetCookie("jaw_uid");

  function getQueryVariable(variable)
  {
        var query = window.location.hash.split('?')[1];
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
                var pair = vars[i].split("=");
                if(pair[0] == variable){return pair[1];}
        }
        return(false);
  }

  try {
    uid = getQueryVariable('jaw_uid')
  } catch (err) { }  

  const jaw_uid =
    `${url}`.indexOf("dtk_go_app_api") > -1 && uid
      ? { app_token: uid }
      : uid && `${url}`.indexOf("taobaoapi") > -1
      ? { jaw_uid: uid }
      : `${url}`.indexOf("php-api") > -1
      ? { is_new_pc: 1 }
      : {};
  // isNoMid = true 不传mid
  const datas = { ...(data ? data : {}), ...jaw_uid ,...(`${url}`.indexOf("cms-v2") > -1 && !isNoMid ? {siteId: window.$mid} : {})};
  const urls = "https://dtkapi.ffquan.cn" + url;
  // const urls = "https://dtkapi.buydance.com" + url;

  return parmas.method === "POST"
    ? requestEvent.post(urls, datas)
    : requestEvent.get(urls, { ...{ params: datas }, ...parmas });
};



// WEBPACK FOOTER //
// ./src/utils/request.js